/** 工作区页面布局模式 */
export type WorkspacePageLayoutMode = 'single' | 'horizontal' | 'vertical';

export const WORKSPACE_PAGE_LAYOUT_MODES: WorkspacePageLayoutMode[] = [
  'single',
  'horizontal',
  'vertical',
];

export const DEFAULT_WORKSPACE_PAGE_LAYOUT_MODE: WorkspacePageLayoutMode = 'single';

export function isWorkspacePageLayoutMode(value: unknown): value is WorkspacePageLayoutMode {
  return typeof value === 'string' && WORKSPACE_PAGE_LAYOUT_MODES.includes(value as WorkspacePageLayoutMode);
}
